import { pcDataLayer } from '.';

export class ErrorHelper {
  private _hasInvalidCardTypeError = false;
  private _hasPaymentFailedError = false;
  private _hasVerifyPaymentError = false;

  private _hasUnableToFindLeaseError = false;

  private _hasUnableCheckoutFailureCase = false;

  private _hasUnableSubmitFailureCase = false;

  private _hasFailedOtpError = false;

  private _hasGenericError = false;

  private _hasStateValidError = false;

  public get hasInvalidCardTypeError() {
    return this._hasInvalidCardTypeError;
  }

  public set hasInvalidCardTypeError(newVal: boolean) {
    if (newVal && newVal !== this._hasInvalidCardTypeError) {
      pcDataLayer.gtmErrorMessageShown('hasInvalidCardTypeError');
    }

    this._hasInvalidCardTypeError = newVal;
  }

  public get hasPaymentFailedError() {
    return this._hasPaymentFailedError;
  }

  public set hasPaymentFailedError(newVal: boolean) {
    if (newVal && newVal !== this._hasPaymentFailedError) {
      pcDataLayer.gtmErrorMessageShown('hasPaymentFailedError');
    }

    this._hasPaymentFailedError = newVal;
  }

  public get hasVerifyPaymentError() {
    return this._hasVerifyPaymentError;
  }

  public set hasVerifyPaymentError(newVal: boolean) {
    if (newVal && newVal !== this._hasVerifyPaymentError) {
      pcDataLayer.gtmErrorMessageShown('hasVerifyPaymentError');
    }

    this._hasVerifyPaymentError = newVal;
  }

  public get hasUnableToFindLeaseError() {
    return this._hasUnableToFindLeaseError;
  }

  public set hasUnableToFindLeaseError(newVal: boolean) {
    if (newVal && newVal !== this._hasUnableToFindLeaseError) {
      pcDataLayer.gtmErrorMessageShown('hasUnableToFindLeaseError');
    }

    this._hasUnableToFindLeaseError = newVal;
  }

  public get hasGenericError() {
    return this._hasGenericError;
  }

  public set hasGenericError(newVal: boolean) {
    if (newVal && newVal !== this._hasGenericError) {
      pcDataLayer.gtmErrorMessageShown('hasGenericError');
    }

    this._hasGenericError = newVal;
  }

  public get hasUnableCheckoutFailureCase() {
    return this._hasUnableCheckoutFailureCase;
  }

  public set hasUnableCheckoutFailureCase(newVal: boolean) {
    if (newVal && newVal !== this._hasUnableCheckoutFailureCase) {
      pcDataLayer.gtmErrorMessageShown('hasUnableCheckoutFailureCase');
    }

    this._hasUnableCheckoutFailureCase = newVal;
  }

  public get hasUnableSubmitFailureCase() {
    return this._hasUnableSubmitFailureCase;
  }

  public set hasUnableSubmitFailureCase(newVal: boolean) {
    if (newVal && newVal !== this._hasUnableSubmitFailureCase) {
      pcDataLayer.gtmErrorMessageShown('hasUnableSubmitFailureCase');
    }

    this._hasUnableSubmitFailureCase = newVal;
  }

  public get hasFailedOtpError() {
    return this._hasFailedOtpError;
  }

  public set hasFailedOtpError(newVal: boolean) {
    if (newVal && newVal !== this._hasFailedOtpError) {
      pcDataLayer.gtmErrorMessageShown('hasFailedOtpError');
    }

    this._hasFailedOtpError = newVal;
  }

  public get hasStateValidError() {
    return this._hasStateValidError;
  }

  public set hasStateValidError(newVal: boolean) {
    if (newVal && newVal !== this._hasStateValidError) {
      pcDataLayer.gtmErrorMessageShown('_hasStateValidError');
    }

    this._hasStateValidError = newVal;
  }

  setCCError(statusMsg: string) {
    switch (statusMsg) {
      case 'SIGN_CARD_AUTH_FAILURE':
      case 'CHANGE_CARD_FAILURE':
        this.hasPaymentFailedError = true;
        break;
      case 'SIGN_CARD_DDE_FAILURE':
        this.hasVerifyPaymentError = true;
        break;
      case 'CHANGE_CARD_INVALID':
        this.hasInvalidCardTypeError = true;
        break;
      default:
        this.hasGenericError = true;
        break;
    }
  }

  resetErrorFlags() {
    this.hasInvalidCardTypeError = false;
    this.hasPaymentFailedError = false;
    this.hasVerifyPaymentError = false;
    this.hasUnableToFindLeaseError = false;
    this.hasUnableCheckoutFailureCase = false;
    this.hasUnableSubmitFailureCase = false;
    this.hasGenericError = false;
    this.hasFailedOtpError = false;
    this.hasStateValidError = false;
  }
}
